import axios from '@/axiosInstance.ts'
import axiosOriginalInstance, {AxiosProgressEvent} from 'axios'

/*Get uploaded media*/
export const httpGetUploadedMedia = ({urlParams}: {urlParams: {assignmentId: number}}) =>
    axios.get(`/assignments/${urlParams.assignmentId}/media/uploaded`)

/*Delete media*/
interface HttpDeleteMediaOptions {
    urlParams: {
        assignmentId: number
        mediaId: number
    }
}
export const httpDeleteMedia = ({urlParams}: HttpDeleteMediaOptions) =>
    axios.delete(`/assignments/${urlParams.assignmentId}/media/${urlParams.mediaId}`)

/*Upload media link*/
interface HttpUploadMediaLinkOptions {
    urlParams: {assignmentId: number}
    payload: {media: string}
}
export const httpUploadMediaLink = ({urlParams, payload}: HttpUploadMediaLinkOptions) =>
    axios.post(`/assignments/${urlParams.assignmentId}/media/upload`, payload)

/*Upload media*/
interface HttpUploadMediaOptions {
    url: string
    payload: File
    onUploadProgress: (progressEvent: AxiosProgressEvent) => void
}
export const httpUploadMedia = ({url, payload, onUploadProgress}: HttpUploadMediaOptions) =>
    axiosOriginalInstance.put(url, payload, {onUploadProgress})

/*Confirm upload media*/
export const httpConfirmUploadMedia = ({urlParams}: {urlParams: {assignmentId: number; mediaId: number}}) =>
    axios.patch(`/assignments/${urlParams.assignmentId}/media/${urlParams.mediaId}/upload-completed`)
